import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import GlassConfiguratorImage from 'assets/Glass_icon_green.svg';
import ICurrentUser from 'api/interfaces/users/ICurrentUser';
import OffersImage from 'assets/DashboardOffers.svg';
import ProBuilderImage from 'assets/ProBuilder_icon_green.svg';
import ProMountImage from 'assets/ProMount_icon_green.svg';
import translations from 'services/translations/translations';

import { OFFERS } from 'services/types/viewTypes';

import DashboardLink from './layout/buttons/DashboardButton';

import 'style/Dashboard.css';

const Home = (): JSX.Element => {
  const { t } = useTranslation([
    translations.common,
    translations.products,
    translations.dashboard,
  ]);

  const currentUser: ICurrentUser = useSelector(
    (state: any) => state.users.current
  );

  const userHasOneOfThePermissions = (...permissions: string[]) =>
    permissions
      .map((permission) => currentUser.views.includes(permission))
      .reduce((any, current) => any || current, false);

  return (
    <>
      <h2 className="dashboard-header">
        {t('dashboard:Greetings', { name: currentUser.firstName })}
      </h2>
      <div className="dashboard-grid">
        {/* The tools on the front page; the projects, contacts and products are in the
            side menu */}
        {userHasOneOfThePermissions(OFFERS) ? (
          <DashboardLink
            id="2"
            image={OffersImage}
            description={t('dashboard:descriptions.offers')}
            link="offers"
            // The name of the offers tool on the front page
            value={t('dashboard:Offers button')}
          />
        ) : null}

        <DashboardLink
          external
          id="5"
          description={t('dashboard:descriptions.glass')}
          image={GlassConfiguratorImage}
          link={currentUser.glassConfigurator}
          value={t(`${translations.common}:Glass configurator`)}
        />

        {currentUser.proBuilder ? (
          <DashboardLink
            external
            id="6"
            description={t('dashboard:descriptions.proBuilder')}
            image={ProBuilderImage}
            link={currentUser.proBuilder}
            value="ProBuilder"
          />
        ) : null}

        {currentUser.proMount ? (
          <DashboardLink
            external
            id="7"
            description={t('dashboard:descriptions.proMount')}
            image={ProMountImage}
            link={currentUser.proMount}
            value="ProMount"
          />
        ) : null}
      </div>
    </>
  );
};

export default Home;
